import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';


class AraziTuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "AraziTuru";
    super(baseUrl);
  }


  getAraziTuruiste(araziTuru?: number){
    
    return this.get("", {params:{ araziTuru: araziTuru}});

   
  }

}
export default new AraziTuruAPI();
class AraziTuruListeRequest {
  public araziTuru?: number;
  constructor(araziTuru?: number ) {
   
      this.araziTuru = araziTuru;

  }
}
export { AraziTuruListeRequest };